import { WorkflowActionId } from "@sp-crm/core";
import { WorkflowPayload } from "generated/graphql";
import { actionEntityId, withActionEntityDelayRecipe } from "./builder-helper";

const actionIndexOf = (payload: WorkflowPayload, actionId: WorkflowActionId): number =>
    (payload.actionEntities ?? []).findIndex(
        action => actionEntityId(action) === actionId,
    );

export const withActionInterval = (
    payload: WorkflowPayload,
    actionId: WorkflowActionId,
    delayRecipe: string,
): WorkflowPayload => {
    const index = actionIndexOf(payload, actionId);
    if (index <= 0) {
        return payload;
    }
    return {
        ...payload,
        actionEntities: payload.actionEntities.map((action, actionIndex) =>
            actionIndex === index
                ? withActionEntityDelayRecipe(action, delayRecipe)
                : action,
        ),
    };
};
